import WarrantyServiceFacade from "@robotical/appv2-warranty-service-lib/dist/facade/WarrantyServiceFacade";
import Logger from "../services/logger/Logger";

const SHOW_LOGS = true;
const TAG = "EmailManager";
export default class EmailManager {

    static async addAlternativeEmail(userPrimary: string, alternativeEmail: string): Promise<boolean> {
        Logger.info(SHOW_LOGS, TAG, "Adding alternative email: " + alternativeEmail + " to user: " + userPrimary);
        const wasAdded = WarrantyServiceFacade.addAlternativeEmailToUser(userPrimary, alternativeEmail);
        return wasAdded;
    }

    static async removeAlternativeEmail(userPrimary: string, alternativeEmail: string) {
        Logger.info(SHOW_LOGS, TAG, "Removing alternative email: " + alternativeEmail + " from user: " + userPrimary);
        const wasRemoved = WarrantyServiceFacade.removeAlternativeEmailFromUser(userPrimary, alternativeEmail);
        return wasRemoved;
    }

    static async swapPrimaryEmail(oldPrimaryEmail: string, oldAlternativeEmail: string) {
        Logger.info(SHOW_LOGS, TAG, "Swapping primary email: " + oldPrimaryEmail + " with alternative email: " + oldAlternativeEmail);
        const wasSwapped = await WarrantyServiceFacade.swapPrimaryAndAlternativeEmails(oldPrimaryEmail, oldAlternativeEmail);
        return wasSwapped;
    }
}